// extracted by mini-css-extract-plugin
export default {"project":"Projects_project__3utEP","projectBg":"Projects_projectBg__K7UoV","projectContent":"Projects_projectContent__A7bV1"};